"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineCheckinForm = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const react_uid_1 = require("react-uid");
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const Navigation_1 = __importDefault(require("../ShoppingCart/Navigation"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const withLazy_1 = __importDefault(require("../../../common/decorators/withLazy"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const helpers_1 = require("../../../common/helpers/helpers");
const useProviderLogin_1 = __importDefault(require("../../../common/helpers/Hooks/useProviderLogin"));
const TextField_1 = __importDefault(require("../FormFields/TextField"));
const AreaSelect_1 = __importDefault(require("../FormFields/AreaSelect"));
const Toggle_1 = __importDefault(require("../FormFields/Toggle"));
const useRedirectToKeyCardActivation_1 = require("../../behaviours/useRedirectToKeyCardActivation");
const OnlineCheckinFlow_1 = require("./OnlineCheckinFlow");
const ExternalCheckinLinkout_1 = __importDefault(require("../Pages/ExternalCheckinLinkout"));
const DateAndTime = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "DateAndTime2564379" */ '../FormFields/DateAndTime')))));
const Wrapper = styled_components_1.default.div `
  color: #666;
`;
const FormWrapper = styled_components_1.default.div `
  background: #fff;
  font-size: 1rem;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100% - 56px);
  @media (min-width: 600px) {
    height: calc(100% - 64px);
  }
`;
const ErrorMessageWrapper = styled_components_1.default.div `
  padding: 0 10px 10px;
  font-size: 1rem;
  text-align: center;
  color: #ff0000;
`;
const ErrorWrapper = styled_components_1.default.div `
  padding: 20px;
  font-size: 1rem;
  text-align: center;
`;
const ButtonWrapper = styled_components_1.default.div `
  position: relative;
  padding: 16px 0;
  text-align: center;
  margin: 0 auto;
`;
const FormTitle = styled_components_1.default.div `
  text-align: center;
  padding: 16px;
  font-size: 2rem;
  color: #212121;
`;
const FormDescription = styled_components_1.default.div `
  text-align: center;
  padding-bottom: 22px;
  font-size: 1.2rem;
`;
const Separator = styled_components_1.default.div `
  width: 100%;
  height: 1px;
  background: #d5d5d5;
`;
const SectionHeading = styled_components_1.default.div `
  font-size: 1.3rem;
  color: #212121;
`;
const ProgressBarWrapper = styled_components_1.default.div `
  position: fixed;
  height: 200px;
  top: 56px;
  @media (min-width: 600px) {
    top: 64px;
  }
  z-index: 1;
  height: 3px;
  width: 100%;
  left: 0;
  right: 0;
  background: ${props => helpers_1.Helpers.convertHexToRGBA(props.theme.palette ? props.theme.palette.primary.main : '#000', 20)};
`;
const ProgressBarFill = styled_components_1.default.div `
  background: ${props => (props.theme.palette ? props.theme.palette.primary.main : '#fff')};
  width: ${props => `${props.percentage}%`};
  transition: width 0.5s linear;
  height: 100%;
`;
const FormLoader = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    position: relative;
    width: 80%;
    height: 20%;
    background: #fafafa;
    max-width: 400px;
    box-shadow: 0px 2px 2px 0px rgb(0 0 0 / 20%);
    border-radius: 15px;
  }
`;
const PrivacyHint = styled_components_1.default.div `
  margin: 16px 0;
`;
const FormSubmitHint = styled_components_1.default.div `
  margin: 16px 0;
  @media (min-width: 840px) {
    margin: 24px 0;
  }
  display: flex;
  align-items: center;
  border: 1px solid #d5d5d5;
  border-radius: 15px;
  padding: 10px;
  background: #fafafa;
  i.material-icons {
    color: rgba(0, 0, 0, 0.6);
  }
  div:first-child {
    flex-basis: 20%;
    text-align: center;
    padding-right: 10px;
  }
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const OnlineCheckinForm = (props) => {
    const { currentLocale, userData, baseUrl, userLandedOn, history, updateStore, match, setDisplayStep, setDialogOpen, openSpecificErrorDialog, closeDialog, setBalanceData, setStatusData, setDialogData, setHeaderText, openErrorDialog, kioskModeEnabled, linkoutUrl, setLinkoutUrl, venue, } = props;
    let { stayId } = match.params;
    const { reservationId } = match.params;
    const interval = (0, react_1.useRef)(null);
    const autoCheckinInterval = (0, react_1.useRef)(null);
    const updateStatusInterval = (0, react_1.useRef)(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, react_1.useState)(false);
    const [isFormLoading, setIsFormLoading] = (0, react_1.useState)(false);
    const [showDiscardFormDialog, setShowDiscardFormDialog] = (0, react_1.useState)(false);
    const [showTerms, setShowTerms] = (0, react_1.useState)(null);
    const [progressBarPercentage, setProgressBarPercentage] = (0, react_1.useState)(0);
    const [texts, setTexts] = (0, react_1.useState)({
        headline: '',
        submitButton: '',
        submitHint: '',
        htmlPrivacyHint: '',
        text: '',
        title: i18n_js_1.default.t('api_guest_journey_checkin_form_headline'),
    });
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)('');
    const [fields, setFields] = (0, react_1.useState)([]);
    const [stayIdState, setStayId] = (0, react_1.useState)(match.params.stayId);
    const { isLoginRequired, loginUrl, preCheckInLogin } = (0, useProviderLogin_1.default)(userData);
    const [formErrorMessage, setFormErrorMessage] = (0, react_1.useState)('');
    const formWrapperRef = (0, react_1.useRef)(null);
    const documentFieldSuffixes = ['guest_document_type', 'guest_passport_number'];
    const nationalityFieldSuffix = 'guest_nationality';
    const normalize = (value) => String(value !== null && value !== void 0 ? value : '')
        .trim()
        .toLowerCase();
    const getGuestFieldPrefix = (fieldId, suffix) => fieldId.endsWith(suffix) ? fieldId.slice(0, -suffix.length) : '';
    const getNationalityCode = (inputFields, nationalityFieldId) => {
        const guestNationalityField = inputFields.find(field => field.id === nationalityFieldId);
        const nationalityValue = guestNationalityField === null || guestNationalityField === void 0 ? void 0 : guestNationalityField.value;
        if (nationalityValue && typeof nationalityValue === 'object') {
            return nationalityValue.id || nationalityValue.value || '';
        }
        const options = (guestNationalityField === null || guestNationalityField === void 0 ? void 0 : guestNationalityField.options) || [];
        const selectedOption = options.find(option => String(option === null || option === void 0 ? void 0 : option.id) === String(nationalityValue) || String(option === null || option === void 0 ? void 0 : option.value) === String(nationalityValue));
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || String(nationalityValue !== null && nationalityValue !== void 0 ? nationalityValue : '');
    };
    const applyDynamicFrontendMandatoryRules = (inputFields) => {
        return inputFields.map((field) => {
            const documentSuffix = documentFieldSuffixes.find(suffix => field.id.endsWith(suffix));
            if (!documentSuffix) {
                return field;
            }
            const guestPrefix = getGuestFieldPrefix(field.id, documentSuffix);
            const nationalityFieldId = `${guestPrefix}${nationalityFieldSuffix}`;
            const shouldDisableMandatory = normalize(getNationalityCode(inputFields, nationalityFieldId)) === normalize(venue === null || venue === void 0 ? void 0 : venue.countryCode);
            // Preserve backend-required value so we can restore it when nationality changes back.
            const originalMandatory = typeof field.originalMandatory === 'boolean' ? field.originalMandatory : field.mandatory;
            return Object.assign(Object.assign({}, field), { originalMandatory, mandatory: shouldDisableMandatory ? false : originalMandatory });
        });
    };
    (0, react_1.useEffect)(() => () => {
        clearInterval(interval.current);
        clearInterval(autoCheckinInterval.current);
        clearInterval(updateStatusInterval.current);
    }, []);
    const handleTermsClick = evt => {
        const closestAnchorTagParent = evt.target.closest('a');
        if (closestAnchorTagParent) {
            evt.preventDefault();
            if (evt.target.href.includes('hotel-mssngr.com')) {
                apiService_1.default.getKioskLegalTermsPage(evt.target.href).then(result => {
                    setShowTerms(result);
                });
            }
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('click', handleTermsClick);
        return () => {
            window.removeEventListener('click', handleTermsClick);
        };
    }, []);
    const handleValueChange = (activeField) => event => {
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: event.target.value });
            }
            return field;
        }));
    };
    const isLinkout = Boolean(linkoutUrl);
    const formatDate = (date) => `${date.getFullYear()}/${date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
    const handleDateAndTimeChange = (activeField, selectedDate) => {
        const fullDateTime = `${formatDate(new Date(selectedDate))} ${activeField.type === 'datetime' ? helpers_1.Helpers.getHourFromDate(selectedDate) : ''}`;
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: fullDateTime });
            }
            return field;
        }));
    };
    const handleSingleSelectChange = (activeField, selectedOption) => {
        const updatedFields = fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: selectedOption });
            }
            return field;
        });
        if (activeField.id.endsWith(nationalityFieldSuffix)) {
            setFields(applyDynamicFrontendMandatoryRules(updatedFields));
            return;
        }
        setFields(updatedFields);
    };
    const handleCheckboxChange = (activeField, checked) => {
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: checked });
            }
            return field;
        }));
    };
    const getOnlineCheckinForm = () => __awaiter(void 0, void 0, void 0, function* () {
        if (reservationId) {
            const deeplinkWithoutQueryParams = window.location.href.split('?')[0];
            const deeplinkResolve = yield apiService_1.default.resolveDeeplink(currentLocale, deeplinkWithoutQueryParams);
            if (deeplinkResolve.status === 'success') {
                /* eslint-disable-next-line prefer-destructuring */
                stayId = deeplinkResolve.stayId;
                setStayId(deeplinkResolve.stayId);
                updateStore('stayId', deeplinkResolve.stayId);
            }
        }
        const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        let intervalTimer = 2000;
        let retryNeeded = false;
        yield apiService_1.default.getReservationForm(currentLocale, token, stayId, kioskModeEnabled).then((data) => {
            if (data.linkoutUrl) {
                setLinkoutUrl === null || setLinkoutUrl === void 0 ? void 0 : setLinkoutUrl(data.linkoutUrl);
                setIsLoading(false);
                return;
            }
            if (data.status === 'error') {
                setError(data.message);
                setIsLoading(false);
                return;
            }
            if (data.nextWorkflow === 'generic_key_card') {
                (0, useRedirectToKeyCardActivation_1.useRedirectToKeycardActivation)({ data, baseUrl, history });
                return;
            }
            if (data.screen === 'status') {
                closeDialog();
                setStatusData(data);
                setHeaderText(data.texts.title);
                setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                setIsLoading(false);
                return;
            }
            if (data.status === 'success') {
                setFields(applyDynamicFrontendMandatoryRules(data.fields));
                setTexts(data.texts);
                setHeaderText(data.texts.title);
                setIsLoading(false);
                return;
            }
            if (data.status === 'retry') {
                retryNeeded = true;
                if (data.interval) {
                    intervalTimer = data.interval;
                }
            }
        });
        if (retryNeeded) {
            interval.current = setInterval(() => {
                apiService_1.default
                    .getReservationForm(currentLocale, token, stayId, kioskModeEnabled)
                    .then((data) => {
                    if (data.linkoutUrl) {
                        setLinkoutUrl === null || setLinkoutUrl === void 0 ? void 0 : setLinkoutUrl(data.linkoutUrl);
                        clearInterval(interval.current);
                        setIsLoading(false);
                        return;
                    }
                    if (data.status === 'error') {
                        setError(data.message);
                        clearInterval(interval.current);
                        setIsLoading(false);
                        return;
                    }
                    if (data.nextWorkflow === 'generic_key_card') {
                        (0, useRedirectToKeyCardActivation_1.useRedirectToKeycardActivation)({ data, baseUrl, history });
                        return;
                    }
                    if (data.screen === 'status') {
                        closeDialog();
                        setStatusData(data);
                        setHeaderText(data.texts.title);
                        setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                        setIsLoading(false);
                        return;
                    }
                    if (data.status === 'success') {
                        setFields(applyDynamicFrontendMandatoryRules(data.fields));
                        setTexts(data.texts);
                        setHeaderText(data.texts.title);
                        clearInterval(interval.current);
                        setIsLoading(false);
                        return;
                    }
                    if (data.status === 'retry') {
                        // just wait for the next tick of the interval
                    }
                    else {
                        clearInterval(interval.current);
                        setIsLoading(false);
                    }
                })
                    .catch(() => {
                    clearInterval(interval.current);
                    openErrorDialog();
                });
            }, intervalTimer);
        }
    });
    const handleBillingAddressChange = (activeField, checked) => {
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: String(+checked) });
            }
            return field;
        }));
        const preparedFields = helpers_1.Helpers.prepareBookingFields(fields, 'stay');
        setIsFormLoading(true);
        const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        apiService_1.default
            .reloadReservationForm(currentLocale, token, stayIdState, preparedFields, kioskModeEnabled)
            .then((data) => {
            setFields(applyDynamicFrontendMandatoryRules(data.fields));
            setIsFormLoading(false);
        });
    };
    const initializeCheckin = () => __awaiter(void 0, void 0, void 0, function* () {
        setDialogOpen();
        let intervalTimer = 1000;
        const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        yield apiService_1.default
            .initializeCheckin(currentLocale, token, stayIdState, kioskModeEnabled)
            .then((data) => {
            if (data.screen === 'status') {
                closeDialog();
                setStatusData(data);
                setHeaderText(data.texts.title);
                setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
            }
            else if (data.status === 'success') {
                closeDialog();
                setBalanceData(data);
                setHeaderText(data.texts.title);
                setDisplayStep(OnlineCheckinFlow_1.INVOICE_SCREEN);
            }
            else if (data.status === 'retry') {
                setDialogData({
                    text: data.texts.text,
                    actionText: data.texts.cancelButton,
                    showProgress: true,
                });
                if (data.interval) {
                    intervalTimer = data.interval;
                }
            }
            else if (data.status === 'error') {
                openSpecificErrorDialog(data.message);
            }
        })
            .catch(() => {
            openErrorDialog();
        });
        interval.current = setInterval(() => {
            apiService_1.default
                .initializeCheckin(currentLocale, token, stayIdState, kioskModeEnabled)
                .then((data) => {
                if (data.texts && data.texts.htmlText) {
                    clearInterval(interval.current);
                    closeDialog();
                    setStatusData(data);
                    setHeaderText(data.texts.title);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                }
                else if (data.status === 'success') {
                    clearInterval(interval.current);
                    closeDialog();
                    setBalanceData(data);
                    setHeaderText(data.texts.title);
                    setDisplayStep(OnlineCheckinFlow_1.INVOICE_SCREEN);
                }
                else if (data.status === 'error') {
                    clearInterval(interval.current);
                    openSpecificErrorDialog(data.message);
                }
            })
                .catch(() => {
                clearInterval(interval.current);
                openErrorDialog();
            });
        }, intervalTimer);
    });
    const handleSubmit = event => {
        event.preventDefault();
        setIsSubmitDisabled(true);
        setIsFormLoading(true);
        setFormErrorMessage('');
        let indexOfBillingCountry = null;
        fields.find((field, index) => {
            const foundBillingAddressCountry = field.id === 'guest_billing_country';
            if (foundBillingAddressCountry) {
                indexOfBillingCountry = index;
            }
            return foundBillingAddressCountry;
        });
        if (indexOfBillingCountry && !fields[indexOfBillingCountry].value) {
            fields[indexOfBillingCountry].value = String(fields[indexOfBillingCountry].options[0].id);
        }
        const preparedFields = helpers_1.Helpers.prepareBookingFields(fields, 'stay');
        const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        apiService_1.default
            .updateUserReservation(currentLocale, token, stayIdState, preparedFields, kioskModeEnabled)
            .then((data) => {
            if (data.status === 'retry') {
                updateStatusInterval.current = setInterval(() => {
                    apiService_1.default
                        .getUserReservationUpdateStatus(currentLocale, token, stayIdState, kioskModeEnabled)
                        .then((updateStatusData) => {
                        if (data.status === 'error') {
                            setError(updateStatusData.message);
                            clearInterval(interval.current);
                        }
                        else if (updateStatusData.nextWorkflow === 'generic_key_card') {
                            (0, useRedirectToKeyCardActivation_1.useRedirectToKeycardActivation)({ data: updateStatusData, baseUrl, history });
                        }
                        else if (updateStatusData.screen === 'status') {
                            closeDialog();
                            setStatusData(updateStatusData);
                            setHeaderText(updateStatusData.texts.title);
                            setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                        }
                    });
                }, data.interval);
            }
            else if (data.status === 'success') {
                if (data.screen === 'status') {
                    setStatusData(data);
                    setHeaderText(data.texts.title);
                    setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                    setIsSubmitDisabled(false);
                    setIsFormLoading(false);
                    return;
                }
                initializeCheckin();
            }
            else if (data.status === 'error') {
                const updatedFields = fields.map(field => {
                    const errorField = data.fields.find(error => error.id === field.id);
                    return errorField ? Object.assign(Object.assign({}, field), { errors: errorField.errors }) : field;
                });
                setFields(updatedFields);
                if (data.message) {
                    setFormErrorMessage(data.message);
                    setTimeout(() => {
                        const errorElement = document.querySelector('[data-testid="form-error-message"]');
                        const progressBar = document.querySelector('[data-testid="progress-bar-wrapper"]');
                        const navigation = document.querySelector('.MuiToolbar-root');
                        if (errorElement) {
                            let parent = errorElement.parentElement;
                            while (parent && parent.getBoundingClientRect().y !== 0) {
                                parent = parent.parentElement;
                            }
                            if (parent) {
                                const actualOffset = ((progressBar === null || progressBar === void 0 ? void 0 : progressBar.getBoundingClientRect().height) || 0) +
                                    ((navigation === null || navigation === void 0 ? void 0 : navigation.getBoundingClientRect().height) || 0);
                                parent.scrollTo({
                                    top: 0,
                                    behavior: 'smooth',
                                });
                                setTimeout(() => {
                                    window.scrollTo({
                                        top: actualOffset + 30,
                                        behavior: 'smooth',
                                    });
                                }, 100);
                            }
                        }
                    }, 200); // wait for timeout on onClick event
                }
                const firstErrorField = updatedFields.find(field => field.errors && field.errors.length > 0);
                if (firstErrorField && fieldRefs.current[firstErrorField.id]) {
                    fieldRefs.current[firstErrorField.id].focus();
                }
                setIsSubmitDisabled(false);
                setIsFormLoading(false);
            }
        })
            .catch(() => {
            setIsSubmitDisabled(false);
            setIsFormLoading(false);
        });
    };
    const fieldRefs = (0, react_1.useRef)({});
    const renderFields = () => fields
        .filter(field => field.semanticType !== 'ends_at')
        .map((field, index) => {
        const { type } = field;
        switch (type) {
            case 'datetime':
            case 'date': {
                const columns = field.id === 'guest_date_of_birth' ? { xs: 12 } : { xs: 6 };
                return (react_1.default.createElement(material_1.Grid, Object.assign({ item: true }, columns, { key: (0, react_uid_1.uid)(field) }),
                    react_1.default.createElement(DateAndTime, { fieldData: field, onChange: handleDateAndTimeChange })));
            }
            case 'hidden':
                return react_1.default.createElement(react_1.default.Fragment, { key: (0, react_uid_1.uid)(field) });
            case 'select':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(AreaSelect_1.default, { fieldData: field, onChange: handleSingleSelectChange, usePreselectedValue: true, useId: true })));
            case 'section_heading':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(SectionHeading, null,
                        field.label,
                        ":")));
            case 'insert_form': {
                const disableMandatory = field.id === 'home_matches_billing_address';
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(Toggle_1.default, { fieldData: field, onChange: handleBillingAddressChange, disableMandatory: disableMandatory })));
            }
            case 'toggle': {
                const disableMandatory = field.id === 'allow_marketing_emails';
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(Toggle_1.default, { fieldData: field, onChange: handleCheckboxChange, disableMandatory: disableMandatory })));
            }
            case 'section_separator':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(Separator, null)));
            default:
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(TextField_1.default, { fieldData: field, onChange: handleValueChange, ref: el => (fieldRefs.current[field.id] = el) })));
        }
    });
    (0, react_1.useEffect)(() => {
        const isAutoCheckin = match.path.includes('guest_journey_auto_checkin');
        if (isAutoCheckin) {
            setDialogOpen();
            const intervalTimer = 1000;
            autoCheckinInterval.current = setInterval(() => {
                apiService_1.default
                    .autoCheckin(currentLocale, userData.token)
                    .then((data) => {
                    if (data.screen === 'status') {
                        clearInterval(autoCheckinInterval.current);
                        setStatusData(data);
                        setHeaderText(data.texts.title);
                        setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
                        closeDialog();
                    }
                    else if (data.status === 'retry') {
                        setDialogData({
                            text: data.texts.text,
                            actionText: data.texts.cancelButton,
                            showProgress: true,
                        });
                    }
                    else if (data.status === 'error') {
                        clearInterval(autoCheckinInterval.current);
                        openSpecificErrorDialog(data.message);
                    }
                })
                    .catch(() => {
                    clearInterval(autoCheckinInterval.current);
                    openErrorDialog();
                });
            }, intervalTimer);
            return;
        }
        getOnlineCheckinForm();
    }, []);
    (0, react_1.useEffect)(() => {
        const editableFields = fields.filter((field) => field.type !== 'section_heading' &&
            field.type !== 'insert_form' &&
            field.type !== 'section_separator' &&
            field.type !== 'toggle' &&
            field.mandatory);
        const dirtyFields = editableFields.filter((field) => field.value && field.errors.length < 1);
        setProgressBarPercentage((dirtyFields.length / editableFields.length) * 100);
    }, [fields]);
    const goBack = () => {
        if (window.location.pathname === userLandedOn) {
            history.push(baseUrl);
        }
        else {
            history.push(`${baseUrl}/guest_journey`);
            updateStore('userLandedOn', `${baseUrl}/guest_journey`);
        }
    };
    const handleNavigationClick = () => {
        if (error) {
            goBack();
        }
        else {
            setShowDiscardFormDialog(true);
        }
    };
    const handleCheckinDiscard = (action = '') => {
        if (action === 'confirm') {
            goBack();
        }
        else {
            setShowDiscardFormDialog(false);
        }
    };
    if (isLoginRequired && !kioskModeEnabled && !preCheckInLogin) {
        window.location.replace(loginUrl);
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const formRef = (0, react_1.useRef)();
    if (isLinkout) {
        return (react_1.default.createElement(ExternalCheckinLinkout_1.default, { iframeSrc: linkoutUrl || '', headline: i18n_js_1.default.t('api_guest_journey_checkin_form_headline') }));
    }
    return (react_1.default.createElement(Wrapper, { "data-testid": "online-checkin-form-wrapper" },
        !kioskModeEnabled && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Navigation_1.default, { icon: "close", onClick: handleNavigationClick, headline: texts.title }),
            react_1.default.createElement(material_1.Toolbar, null))),
        isLoading ? (react_1.default.createElement(Loader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            error ? (react_1.default.createElement(ErrorWrapper, { "data-testid": "error-wrapper" }, error)) : (react_1.default.createElement(FormWrapper, { ref: formWrapperRef },
                react_1.default.createElement(ProgressBarWrapper, { theme: props.theme, "data-testid": "progress-bar-wrapper" },
                    react_1.default.createElement(ProgressBarFill, { percentage: progressBarPercentage })),
                react_1.default.createElement(FormTitle, null, texts.headline),
                react_1.default.createElement(FormDescription, null, texts.text),
                formErrorMessage && (react_1.default.createElement(ErrorMessageWrapper, { "data-testid": "form-error-message" },
                    i18n_js_1.default.t('message_error'),
                    ": ",
                    formErrorMessage)),
                react_1.default.createElement("form", { ref: formRef, onSubmit: handleSubmit },
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 }, renderFields()),
                    react_1.default.createElement(PrivacyHint, null,
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: texts.htmlPrivacyHint,
                            } })),
                    react_1.default.createElement(FormSubmitHint, null,
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Info_1.default, null)),
                        react_1.default.createElement("div", null, texts.submitHint)),
                    react_1.default.createElement(ButtonWrapper, null,
                        react_1.default.createElement(material_1.Button, { type: "submit", variant: "contained", size: "large", disabled: isSubmitDisabled, fullWidth: true, "data-testid": "submit", onClick: () => 
                            // We do this because safari removes the validation message if you scroll and when we press the submit button
                            // we scroll to the field that has the validation needed thus removing the validation message
                            setTimeout(() => {
                                if (formRef.current) {
                                    formRef.current.reportValidity(); // This retrigger the validation for the form
                                }
                            }, 100) }, texts.submitButton))),
                isFormLoading && (react_1.default.createElement(FormLoader, null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Loader_1.default, null)))))),
            react_1.default.createElement(material_1.Dialog, { "data-testid": "discard-form", open: showDiscardFormDialog, TransitionComponent: Transition, keepMounted: true, onClose: () => handleCheckinDiscard(), "aria-describedby": "alert-dialog-slide-description" },
                react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t('dismiss_registration_title')),
                react_1.default.createElement(material_1.DialogContent, null, i18n_js_1.default.t('dismiss_registration_text')),
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement(material_1.Button, { onClick: () => handleCheckinDiscard() }, i18n_js_1.default.t('continue_editing_button')),
                    react_1.default.createElement(material_1.Button, { "data-testid": "confirm-discard", onClick: () => handleCheckinDiscard('confirm') }, i18n_js_1.default.t('dismiss_button')))),
            react_1.default.createElement(material_1.Dialog, { "data-testid": "legal-terms", open: !!showTerms, TransitionComponent: Transition, "aria-describedby": "alert-dialog-slide-description" },
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement(material_1.Button, { onClick: () => {
                            setShowTerms(null);
                        } },
                        react_1.default.createElement(material_1.IconButton, { size: "large", edge: "start", className: "back-button", "aria-label": "back button" },
                            react_1.default.createElement(Close_1.default, null)))),
                react_1.default.createElement(material_1.DialogContent, null,
                    react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                            __html: showTerms,
                        } })))))));
};
exports.OnlineCheckinForm = OnlineCheckinForm;
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    baseUrl: store.getValue('baseUrl'),
    userLandedOn: store.getValue('userLandedOn'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
    venue: store.getValue('venue'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.OnlineCheckinForm));
